import CustomerId               from "../../../../domain/customer/CustomerId";
import CustomerRecordRepository from "../../../../domain/record/customer/CustomerRecordRepository";
import CustomerRecordDataSource from "../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";

class GetCustomerRecordCount {
  private readonly repository: CustomerRecordRepository = new CustomerRecordDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(customerId: CustomerId, setCount: (value: number) => void, setLoading: (value: boolean) => void) {
    setLoading(true);
    try {
      const response = await this.repository.countBy(customerId);
      setCount(response.data.count);
    } catch (e) {
      setCount(0);
    } finally {
      setLoading(false);
    }
  }
}

export default GetCustomerRecordCount;
